import { useState } from 'react';
import './AdminLogin.css';

const API_BASE_URL = process.env.REACT_APP_API_URL;

export default function AdminLogin({ onLogin }) {
    const [username, setUsername] = useState('');
    const [password, setPassword] = useState('');
    const [error, setError] = useState('');
    const [loading, setLoading] = useState(false);

    const handleSubmit = async (e) => {
        e.preventDefault();
        setLoading(true);
        setError('');
        try {
            const res = await fetch(`${API_BASE_URL}/admin/login`, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ username, password }),
            });
            const data = await res.json();
            if (res.ok && data.token) {
                localStorage.setItem('adminToken', data.token);
                localStorage.setItem('adminName', data.username);
                onLogin();
            } else {
                setError(data.message || 'بيانات الدخول غير صحيحة');
            }
        } catch {
            setError('تعذر الاتصال بالخادم');
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="admin-login-page">
            <form className="admin-login-box" onSubmit={handleSubmit}>
                <h2>🔐 لوحة التحكم — تسجيل الدخول</h2>
                <input
                    type="text"
                    placeholder="اسم المستخدم"
                    value={username}
                    onChange={(e) => setUsername(e.target.value)}
                    required
                />
                <input
                    type="password"
                    placeholder="كلمة المرور"
                    value={password}
                    onChange={(e) => setPassword(e.target.value)}
                    required
                />
                {error && <p className="admin-login-error">{error}</p>}
                <button type="submit" disabled={loading}>
                    {loading ? 'جارٍ التحقق...' : 'دخول'}
                </button>
            </form>
        </div>
    );
}